import { render, staticRenderFns } from "./MatterManagement.vue?vue&type=template&id=059e74ec&"
import script from "./MatterManagement.vue?vue&type=script&lang=js&"
export * from "./MatterManagement.vue?vue&type=script&lang=js&"
import style0 from "./MatterManagement.vue?vue&type=style&index=0&id=059e74ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports